

















































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import httpResource from "@/components/infrastructures/functions/http/httpResource";
import CalteFormat from "@/components/domains/calte/calteFormat";
import AIEstheDetectFaceResultCard from "@/components/domains/esthe/aiesthe/AIEstheDetectFaceResultCard.vue";
import CalteRecord from "@/components/domains/calte/calteRecord";
import {CalteFormatConverter} from "@/components/domains/calte/calteFormatConverter";
import KawaiiButton from "@/components/infrastructures/atoms/KawaiiButton.vue";
import {User} from "@/components/domains/authorization/user";
import {AuthGetterTypes} from "@/store/auth/types";

@Component({
  components: {KawaiiButton, AIEstheDetectFaceResultCard}
})
export default class CalteList extends Vue {

  @Prop({default: ''}) userId!: string;
  @Prop({default: false}) hiddenTitle!: boolean;

  name = "CalteList";
  options = {}
  items = []
  selectedItems = []
  caltes = []
  total = 0
  loading = false
  calteFormat = new CalteFormat();
  aiEstheResult = null;
  hiddenList = false;
  user: User = this.$store.getters[AuthGetterTypes.getCurrentUser];

  // dialog
  dialog = false;
  overlay = false;
  error = false;

  get getHeaders() {
    let headers = [];
    if (this.userId !== '') {
      headers = [
        {text: 'カルテ名', value: 'name'},
        {text: '顧客記入状況', value: 'filledOut'},
        {text: '日付', value: 'updated'}
      ];
    } else {
      headers = [
        {text: 'カルテ名', value: 'name'},
        {text: '顧客名', value: 'userName'},
        {text: '顧客記入状況', value: 'filledOut'},
        {text: '日付', value: 'updated'}
      ];
    }

    if (this.isPIC()) {
      headers.push({text: '削除', value: 'delete'});
    }
    return headers;
  }

  private isPIC(): boolean {
    return this.user.roles.includes("ROLE_PERSON_IN_CHARGE")
        || this.user.roles.includes("ROLE_ADMIN")
  }

  @Watch("options")
  getDataFromApi() {
    this.loading = true
    this.apiCall().then((data: any) => {
      this.items = data.items;
      this.total = data.total;
    }).catch(error => {
      // TODO: エラーハンドリング
    }).finally(() => {
      this.loading = false;
    })
  }

  @Watch('userId')
  updateData() {
    this.getDataFromApi();
  }

  mounted() {
    this.getDataFromApi()
  }

  async apiCall() {

    const {page, itemsPerPage} = this.options as any

    const size = itemsPerPage == -1 ? this.total : itemsPerPage;
    if (size > 99) {
      alert('100件以上の表示はできません。')
      return;
    }

    // ページ更新するたびにtotal取得するが、動的に担当者がカルテを追加した場合を想定している
    const totalResponse = await httpResource.get(`pic/calte/browsable-count?userId=${this.userId}`);
    const caltesResponse = await httpResource.get(`pic/calte/browsable?userId=${this.userId}&page=${page - 1}&size=${size}`);

    const items = caltesResponse.data.map((v: any) => {
      return {
        id: v.id,
        name: /*v.updated + 'の' + */ v.title,
        userName: v.userName,
        filledOut: !v.customerInput ? '未' : '済',
        updated: v.updated
      }
    })
    const total = totalResponse.data
    return {items, total}
  }

  registerCalte() {

    if (this.calteFormat.hasEmptyInRequiredFields()) {
      alert('未入力項目があります。');
      return;
    }

    // calteformat → calterecord変換
    const item = this.selectedItems[0] as any
    const aiResult = this.aiEstheResult as any
    const calteRecord: CalteRecord = CalteFormatConverter.format2record(item.id, this.calteFormat);

    const request = {
      aiEstheDetectFaceResultId: aiResult === null ? null : aiResult.id,
      calteRecord: calteRecord
    }

    httpResource.post(`common/calte/register-record/`, request)
        .then((response: any) => {
          // NOP
        })
        .catch((error: any) => {
          this.error = true;
        });
    this.dialog = true;
    this.overlay = true;
  }

  deleteCalte(id: string) {
    httpResource.post(`pic/calte/delete-record?calteId=${id}`)
        .then((response: any) => {
          alert("カルテを削除しました。");
          this.$router.go(0);
        });
  }

  deleteButtonDisabled(id: string) {
    if (this.selectedItems.length === 0) {
      return true;
    }
    const item = this.selectedItems[0] as any
    return item.id !== id;
  }

  @Watch("selectedItems")
  private watchSelected() {

    this.aiEstheResult = null;

    if (this.selectedItems.length === 0) {
      return;
    }

    const item = this.selectedItems[0] as any

    // カルテの画像取得
    if (item.id !== null && item.id.trim() !== '') {
      httpResource.get(`aiesthe/detect-result-from-record-calte-id?calteRecordId=${item.id}`)
          .then((response: any) => {
            this.aiEstheResult = response.data
          })
          .catch((error: any) => {
            // NOP
          });
    }

    // カルテ内容取得
    httpResource.get(`pic/calte/get-format-from-record?calteRecordId=${item.id}`)
        .then((response: any) => {
          const id = response.data.calteId;
          const title = response.data.title;
          const items = response.data.calteItems;
          const calteFormat = CalteFormat.createWithId(id, title, items);
          this.calteFormat = calteFormat;
        })
        .catch((error: any) => {
          this.calteFormat = new CalteFormat();
        });
  }

  decide(): void {
    this.dialog = false;
    this.overlay = false;
    this.error = false;
  }
}

